import React from 'react'

export default ({ children }) => (
  <h1 className='text-xl md:text-2xl font-bold mb-2'>
    {children}
  </h1>
)
